<tt-page *ngIf="!!setting">
    <tt-card class="col-xs-12 col-md-3 p-5">
        <tt-select ttRememberId="w_receivables.businessco_no" ttLabel="businessco" [(ttModel)]="setting.businessco_no" (ttModelChange)="onChanged($event, 'businessco_no')" [ttData]="selectListCompanies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
        <tt-date-range ttRememberId="w_receivables" ttLabel="date_fom_tom" ttLabelView="top" [(ttStartDate)]="setting.date_fom" [(ttEndDate)]="setting.date_tom" [(ttInterval)]="setting.dateselector_index" (ttModelChange)="onDateRangeChanged()"></tt-date-range>
        <tt-button ttText="receivables_get_payments" (ttClick)="getChanges()" [ttSpin]="getting" ttIcon="fas fa-sync"></tt-button>

        <tt-tabs ttRememberId="w_receivables.bg_receivables_main" [(ttSelectedId)]="setting.bg_receivables_main" (ttSelectedIdChange)="onTabChange()">
            <tt-tab ttId="ALL" ttLabel="bg_receivables_main_all"></tt-tab>
            <tt-tab ttId="NOT_BOOKED" ttLabel="bg_receivables_main_not_booked"></tt-tab>
            <tt-tab ttId="BOOKED" ttLabel="bg_receivables_main_booked"></tt-tab>
        </tt-tabs>
    </tt-card>

    <tt-grid *ngIf="!!grid" class="flex-1 p-5" [(ttOptions)]="grid"></tt-grid>
</tt-page>
